export default "__VITE_ASSET__DaqWHELP__"